module.exports = __webpack_public_path__ + "static/media/empty_state.ed8a5a81.svg";